import React from 'react';
import {connect} from 'react-redux';
import DVRhealth from './DVRhealth';
import {isMobile} from '../../app/configuration/util';

class DVRHealthPage extends React.Component {
  render() {
    return (
      <div>
        <div className="whitecover" />
        <DVRhealth {...this.props} />
      </div>
    );
  }
}

export default connect(state => ({isMobile: isMobile(state)}))(DVRHealthPage);
